import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemPriceModel extends IModel {
  salesItemPriceId: number;
  salesItemId: number;
  salesItemOptionId: number | undefined;
  startDate: string;
  endDate: string | undefined;
  price: number;
  packageAddOnPrice: number | undefined;
}

export class SalesItemPriceModel
  extends Model
  implements ModelRecord<ISalesItemPriceModel>
{
  salesItemPriceId: number;
  salesItemId: number;
  salesItemOptionId: number | undefined;
  startDate: string;
  endDate: string | undefined;
  price: number;
  packageAddOnPrice: number | undefined;

  constructor(params?: Partial<ISalesItemPriceModel>) {
    super(params);
    this.salesItemPriceId = defaultTo(params?.salesItemPriceId, 0);
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesItemOptionId = defaultTo(params?.salesItemOptionId, undefined);
    this.startDate = defaultTo(params?.startDate, '2000-01-01');
    this.endDate = defaultTo(params?.endDate, undefined);
    this.price = defaultTo(params?.price, 0);
    this.packageAddOnPrice = params?.packageAddOnPrice;
  }
}
